/* LDW: header nav watchdog. The theme's <overflow-list> measures which menu items fit on one line.
   If that measurement runs while fonts are still swapping or a mega-menu is animating, it can
   mis-count and dump most items into MORE, and if it errors mid-reflow it stays stuck. This
   re-runs the reflow after fonts load and after mega-menu close, and resets it when it looks wrong. */
(function(){
  var MIN_VISIBLE=3, DESKTOP=1200, MAX_RESETS=4, resets=0;
  function menu(){ return document.querySelector('header-menu overflow-list[ref="overflowMenu"]'); }
  function items(el){ var a=[]; for (var i=0;i<el.children.length;i++){ var c=el.children[i]; if(c.tagName==='LI' && c.getAttribute('slot')!=='more') a.push(c); } return a; }
  function visibleCount(el){ return items(el).filter(function(c){ return c.getAttribute('slot')!=='overflow'; }).length; }
  function reflow(el){ try{ el.dispatchEvent(new CustomEvent('reflow',{detail:{}})); }catch(e){} }
  function reset(el){
    if(resets>=MAX_RESETS) return; resets++;
    try{ el.setAttribute('disabled','true'); }catch(e){}
    setTimeout(function(){ try{ el.removeAttribute('disabled'); reflow(el); }catch(e){} },60);
  }
  function check(){
    var el=menu(); if(!el || window.innerWidth<DESKTOP) return;
    if(items(el).length>=MIN_VISIBLE && visibleCount(el)<MIN_VISIBLE) reset(el);
  }
  function arm(){
    var el=menu(); if(!el) return;
    if(document.fonts && document.fonts.ready){ document.fonts.ready.then(function(){ setTimeout(function(){ reflow(el); setTimeout(check,300); },50); }); }
    window.addEventListener('load',function(){ setTimeout(check,500); setTimeout(check,2000); });
    document.addEventListener('header-menu:activate',function(){ setTimeout(check,800); });
    var hm=document.querySelector('header-menu'); if(hm){ hm.addEventListener('pointerleave',function(){ setTimeout(check,600); }); }
    var t; window.addEventListener('resize',function(){ clearTimeout(t); t=setTimeout(function(){ resets=0; check(); },400); });
    document.addEventListener('visibilitychange',function(){ if(!document.hidden) setTimeout(check,300); });
    setInterval(check,2500);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',arm); else arm();
})();
